module.exports = __webpack_public_path__ + "static/img/7225_phase_function_Paper_Points.c9982b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7225_phase_function_Paper_Points.png
// module id = 0s2D
// module chunks = 0